import React from "react";
import SimpleTooltip from "./SimpleTooltip";

function PPLabel({ item, isSmall = false }) {
  let ppClassName = "text-xs py-0 px-2 font-semibold";

  if (item.__isProtected) {
    ppClassName += " bg-red-200 text-red-700";
    if (isSmall) {
      return (
        <SimpleTooltip tooltipText="Protected">
          <span className={ppClassName}>P</span>
        </SimpleTooltip>
      );
    }

    return <span className={ppClassName}>PROTECTED</span>;
  }
  if (item.__isPreserved) {
    ppClassName += " bg-orange-200 text-orange-700";
    if (isSmall) {
      return (
        <SimpleTooltip tooltipText="Preserved">
          <span className={ppClassName}>PR</span>
        </SimpleTooltip>
      );
    }
    return <span className={ppClassName}>PRESERVED</span>;
  }
  return "";
}

export default PPLabel;
